import type { MutationStatus } from '@tanstack/react-query'
import { useSnackbar, type VariantType } from 'notistack'
import React, { type HTMLAttributes } from 'react'

interface SnackbarRestStatusProps {
  status: MutationStatus
  statusCode?: number
  messages: { defaultError?: string; success?: string; [key: number]: string }
  onClose?: () => void
}

export const useSnackbarRestStatus = ({
  status,
  statusCode,
  messages,
  onClose,
}: SnackbarRestStatusProps): void => {
  const handledStatus = ['success', 'error']

  const { enqueueSnackbar } = useSnackbar()

  React.useEffect(() => {
    if (handledStatus.includes(status)) {
      let snackbarVariant: VariantType | undefined
      let message

      if (status === 'success') {
        snackbarVariant = 'success'
        message = messages['success']
      } else if (status === 'error') {
        snackbarVariant = 'error'
        message = messages[statusCode || -1] ?? messages['defaultError']
      }
      if (snackbarVariant !== undefined && message) {
        enqueueSnackbar(message, {
          variant: snackbarVariant,
          onClose,
          SnackbarProps: {
            'data-testid': 'snackbar-rest-status',
          } as HTMLAttributes<HTMLDivElement>,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, statusCode])
}
